import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./locales/en.json";
import arTranslation from "./locales/ar.json";
import esTranslation from "./locales/es.json";
import esColTranslation from "./locales/es-col.json";
import ptTranslation from "./locales/pt.json";
import mxTranslation from "./locales/mx.json";
import eeuuTranslation from "./locales/eeuu.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
      pt: { translation: ptTranslation },
      "es-col": { translation: esColTranslation },
      mx: { translation: mxTranslation },
      eeuu: { translation: eeuuTranslation },
      ar: { translation: arTranslation },
    },

    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",

    detection: {
      order: ["querystring", "navigator"],
      lookupQuerystring: "lang",
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
